import React, { type ReactNode } from 'react';

interface IOuterDiv {
  children: ReactNode;
}
export const OuterDiv = ({ children }: IOuterDiv) => {
  return <div className="bg-danger-subtle text-danger position-fixed end-0 top-50 z-3 me-1">{children}</div>;
};
